import { Stack } from "@mui/material";
import { Suspense, useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { hydrateStore } from "./app/hydrateStore.js";
import ErrorBoundary from "./components/ErrorBoundary.js";
import LoadingScreen from "./components/loaders/LoadingScreen.js";
import useHubspotTracking from "./hooks/useHubspotTracking.js";
import { JumpScrollButton, ScrollToTop } from "./hooks/useScroll.js";
import ErrorPage from "./pages/ErrorPage.js";
import Router from "./router/index.js";

// GTM SETUP
TagManager.initialize({ gtmId: "GTM-TGKJCZNW" });

const App = () => {
  useHubspotTracking();
  const [hydrated, setHydrated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    hydrateStore()
      .catch((_err) => {
        if (isMounted) navigate("/error");
      })
      .finally(() => isMounted && setHydrated(true));

    return () => {
      isMounted = false;
    };
  }, []);

  if (!hydrated) return <LoadingScreen />;

  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <Suspense fallback={<LoadingScreen />}>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          className="App"
        >
          <ScrollToTop />
          <JumpScrollButton />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            style={{ zIndex: 9999999999 }}
            closeOnClick
            pauseOnHover
          />
          <Router />
        </Stack>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
